/* eslint react/no-danger: 0 */
import classNames from 'classnames';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './Toast.less';

const noop = () => {};

class Toast extends Component {
    static propTypes = {
        autoClose: PropTypes.bool,
        autoCloseAfter: PropTypes.number,
        onAutoClose: PropTypes.func,
        onCloseClick: PropTypes.func,
        onClose: PropTypes.func,
        onContentClick: PropTypes.func,
        onRemove: PropTypes.func,
        renderContent: PropTypes.func.isRequired,
        thumbnail: PropTypes.string,
        type: PropTypes.oneOf(['default', 'inverse']),
        id: PropTypes.number
    }

    static defaultProps = {
        autoClose: true,
        autoCloseAfter: 5000, // 5 seconds,
        onAutoClose: noop,
        onCloseClick: noop,
        onClose: noop,
        onContentClick: noop,
        onRemove: noop,
        renderContent: noop,
        thumbnail: null,
        type: 'default'
    }

    constructor(props) {
        super(props);

        this.timeoutId = null;

        this.state = {
            isAdded: false,
            isClosed: false,
            isRemoved: false
        };
    }

    componentDidMount() {
        const {autoClose, autoCloseAfter, onAutoClose} = this.props;
        const {isClosed} = this.state;
        if (autoClose) {
            this.timeoutId = setTimeout(() => {
                if (!isClosed) {
                    onAutoClose(this.props);
                    this.close();
                }
            }, autoCloseAfter);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timeoutId);
    }

    add = () => {
        if (this.state.isAdded) {
            return;
        }

        this.setState({
            isAdded: true
        });
    }

    close = () => {
        if (this.state.isClosed) {
            return;
        }

        clearTimeout(this.timeoutId);

        // animate out
        this.setState({
            isClosed: true
        });

        this.props.onClose(this.props);
        this.remove();
    }

    handleCloseClick = () => {
        this.props.onCloseClick(this.props);
        this.close();
    }

    handleContentClick = (e) => {
        this.props.onContentClick(e, this.props);
    }

    remove = () => {
        // animate removal
        setTimeout(() => {
            this.setState({
                isRemoved: true
            });
        }, 250);

        // trigger callback so container can update additional state
        // all animations take 500ms, so giving removal animations time to complete
        setTimeout(() => {
            this.props.onRemove(this.props.id);
        }, 750);
    }

    render() {
        const {isAdded, isClosed, isRemoved} = this.state;
        const {renderContent, thumbnail, type} = this.props;
        const containerClasses = classNames({
            'toaster__toast': true,
            'is-added': isAdded,
            'is-closed': isClosed,
            'is-removed': isRemoved,
            'toaster__toast-inverse': type === 'inverse'
        });

        // animate in
        setTimeout(this.add, 250);

        return (
            <div className={containerClasses}>
                <button
                    className="btn btn-link btn-sm toaster__toast-x"
                    onClick={this.handleCloseClick}
                    type="button"
                >
                    <svg className="toaster__toast-svg toaster__toast-x-svg inline-svg">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#toast-x" />
                    </svg>
                </button>
                <div
                    className="toaster__toast-flex"
                    onClick={this.handleContentClick}
                >
                    {thumbnail && <img className="toaster__toast-thumbnail" src={`${thumbnail}`}/>}
                    <span className="toaster__toast-message">
                        {renderContent()}
                    </span>
                </div>
            </div>
        );
    }
}


export default Toast;
